import * as React from "react";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";
import { CircularProgress } from "@mui/material";

const SelectProjectsAutocomplete = ({
    projectNames,
    projectsToSetup,
    setProjectsToSetup,
    projects,
    loading,
}) => {
    if (!projects || !projectNames) return null;

    const handleProjectsChange = (event, newValue) => {
        const projectsMap = new Map(projectsToSetup.map((proj) => [proj.name, proj]));
        const updatedProjects = newValue
            .map((name) => {
                const project = projects.find((proj) => proj.name === name);
                if (project) {
                    const existingProject = projectsMap.get(name);
                    return {
                        name,
                        fields: existingProject ? existingProject.fields : {},
                        id: project.id,
                    };
                }
                return null;
            })
            .filter(Boolean);

        setProjectsToSetup(updatedProjects);
    };

    const selectedValues = React.useMemo(
        () => projectsToSetup.map((s) => s.name),
        [projectsToSetup]
    );

    return (
        <Stack spacing={3} style={{ width: "100%" }}>
            <Autocomplete
                multiple
                id="tags-outlined"
                options={projectNames}
                value={selectedValues}
                onChange={handleProjectsChange}
                getOptionLabel={(option) => option}
                defaultValue={projectNames[0]}
                filterSelectedOptions
                loading={loading}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        label="Select projects"
                        sx={{ fontSize: 12 }}
                        slotProps={{
                            input: {
                                ...params.InputProps,
                                endAdornment: (
                                    <>
                                        {loading ? (
                                            <CircularProgress color="inherit" size={20} />
                                        ) : null}
                                        {params.InputProps.endAdornment}
                                    </>
                                ),
                            },
                        }}
                    />
                )}
            />
        </Stack>
    );
};

export default SelectProjectsAutocomplete;
